export const GET_TENANT_LIST = 'GET_TENANT_LIST';

export function getTenantsList(data) {
    return function (dispatch) {
        dispatch({ type: GET_TENANT_LIST, addedTenants: data });
    };
}